// Common
import { ComponentRef, Directive, Input } from '@angular/core';

// Directives
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';

// Components
import { SidebarContextMenuComponent } from '@modules/sheets/components/sidebar-context-menu/sidebar-context-menu.component';

// Types
import { VirtualFolder } from '../types/virtual-folder';

@Directive({
  selector: '[appSidebarContextMenu]',
  standalone: false,
})
export class SidebarContextMenuDirective extends ContextMenuDirective {
  // Inputs
  @Input() appSidebarContextMenu: VirtualFolder;

  registerComponent() {
    return SidebarContextMenuComponent;
  }

  registerInstance(componentRef: ComponentRef<SidebarContextMenuComponent>) {
    componentRef.instance.sidebarFilterKey = this.appSidebarContextMenu;
  }
}
